import isNull from 'lodash/isNull.js';
import isPlainObject from 'lodash/isPlainObject.js';
/**
 * A guard for objects that ensures they are plain objects, and thus, can
 * reasonably be typed as a Record.
 */
export function isRecord(maybeRecord) {
    return isPlainObject(maybeRecord);
}
/**
 A guard for objects that ensures they are iterable records objects
 not as strict as isRecord but better performance when that matters
 */
export function isIterableObject(x) {
    return Boolean(x) && typeof x === 'object';
}
/**
 * Create enum matchers, which will return the enum entry from the provided
 * enum when the value matches.
 */
export function createEnumMatcher(enumVariable) {
    return (testValue) => Object.entries(enumVariable).find(([, enumValue]) => enumValue === testValue);
}
export function isPrimitive(maybePrimitive) {
    return (typeof maybePrimitive === 'string' ||
        typeof maybePrimitive === 'number' ||
        typeof maybePrimitive === 'boolean' ||
        typeof maybePrimitive === 'symbol' ||
        typeof maybePrimitive === 'undefined' ||
        typeof maybePrimitive === 'bigint' ||
        isNull(maybePrimitive));
}
export function isScalar(maybeScalar) {
    return (typeof maybeScalar === 'string' ||
        typeof maybeScalar === 'number' ||
        typeof maybeScalar === 'boolean' ||
        typeof maybeScalar === 'bigint');
}
export function getSingle(t) {
    if (Array.isArray(t)) {
        return t[0];
    }
    return t;
}
/**
 * Test whether a provided string is numeric, e.g., '9' is numeric while 'nine' is not.
 */
export function isNumericString(key) {
    return !Number.isNaN(Number(key));
}
